const ForgotPassword = {

    // FIELDS
    "otp": "OTP",

    // BUTTON
    "send_otp": "Send Otp",
    "verify_otp": "Verify Otp",

    // TOAST
    "success_sent_otp": "OTP sent successfully. Enter OTP to verify your email.",
    "success_verified_otp": "OTP verified successfully. You can now change your password.",
    "success_change_password": "Password changed successfully. You can now login with your new password.",

    // ERROR
    "error_otp": "Enter OTP",
    "error_otp_digit": "OTP must be exactly 4 digits",

}

export default ForgotPassword;